/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-20 15:41:35
 * @LastEditTime: 2020-08-24 10:55:39
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/role.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getTableHeaderApi,
  getTableDataApi,
  getChangeDataApi,
  deleteDataApi,
  postDataApi,
  getUserApi,
  getUserItemApi
} from "@/service/roleService";

const role = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getRoleHeader(store, id) {
      return new Promise((resolve, reject) => {
        getTableHeaderApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getRoleData(store, idInfo) {
      return new Promise((resolve, reject) => {
        getTableDataApi(idInfo)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getChangeRoleData(store, data) {
      return new Promise((resolve, reject) => {
        getChangeDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteRoleData(store, id) {
      return new Promise((resolve, reject) => {
        deleteDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    postRoleData(store, data) {
      return new Promise((resolve, reject) => {
        postDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getRoleUser(store, id) {
      return new Promise((resolve, reject) => {
        getUserApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getRoleUserItem(store, id) {
      return new Promise((resolve, reject) => {
        getUserItemApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default role;



// WEBPACK FOOTER //
// ./src/store/modules/role.js